import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmailLogs } from '@/pages/super-admin/email-logs';

const emailLogsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	status: z.enum(['SENT', 'DELIVERED', 'BOUNCED', 'COMPLAINED']).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/email-logs')({
	component: EmailLogs,
	validateSearch: emailLogsSearchSchema,
});
